import { useMemo, useState } from 'react';
import { FilterMatchMode } from 'primereact/api';
import { useGetBulletinImplementationReportQuery } from '../../../../api/endpoints/bulletinImplementationReport';
import { matchModeToOperator } from '../../../../utils/filterUtils';
import { formatDateForApi } from '../../../../utils/dateUtils';

export const REPORT_FIELDS = [
    { field: 'bultenNo', backend: 'BultenNo' },
    { field: 'sasiNo', backend: 'SasiNo' },
    { field: 'bayiAdi', backend: 'BayiAdi' },
    { field: 'ulke', backend: 'Ulke' },
    { field: 'uygulanmaTarihi', backend: 'UygulanmaTarihi', type: 'date' },
    { field: 'yayinlanmaTarihi', backend: 'YayinlanmaTarihi', type: 'date' },
    { field: 'uygulanmaDurumu', backend: 'UygulanmaDurumu' }
];
const initialFilters = REPORT_FIELDS.reduce(
    (result, { field, type }) => ({
        ...result,
        [field]: null,
        [`${field}MatchMode`]: field === 'uygulanmaDurumu' ? FilterMatchMode.EQUALS : type === 'date' ? FilterMatchMode.DATE_IS : FilterMatchMode.CONTAINS
    }),
    {}
);

const useBulletinImplementationReportData = () => {
    const [lazyParams, setLazyParams] = useState({ first: 0, rows: 20, page: 1 });
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(0);
    const [activeFilters, setActiveFilters] = useState(initialFilters);
    const queryParams = useMemo(() => {
        const filters = REPORT_FIELDS.flatMap(({ field, backend, type }) => {
            const value = activeFilters[field];
            if (value === null || value === undefined || value === '') return [];
            const filterValue = type === 'date' ? formatDateForApi(value) : String(value).trim();
            if (!filterValue) return [];
            return [{ column: backend, operator: matchModeToOperator[activeFilters[`${field}MatchMode`]] ?? (type === 'date' ? 5 : 1), value: filterValue }];
        });
        const sort = REPORT_FIELDS.find(({ field }) => field === sortField);
        return { pageNumber: lazyParams.page, pageSize: lazyParams.rows, filters: filters.length ? filters : null, sorts: sort && sortOrder ? [{ column: sort.backend, direction: sortOrder === 1 ? 1 : 2 }] : null };
    }, [activeFilters, lazyParams.page, lazyParams.rows, sortField, sortOrder]);
    const { data, isFetching } = useGetBulletinImplementationReportQuery(queryParams);
    return {
        data,
        isLoading: isFetching,
        lazyParams,
        activeFilters,
        sortField,
        sortOrder,
        reset: () => {
            setActiveFilters(initialFilters);
            setSortField(null);
            setSortOrder(0);
            setLazyParams({ first: 0, rows: 20, page: 1 });
        },
        onPage: (event) => setLazyParams({ first: event.first, rows: event.rows, page: event.page + 1 }),
        onSort: (event) => {
            setSortField(event?.sortField ?? null);
            setSortOrder(event?.sortOrder ?? 0);
            setLazyParams((current) => ({ ...current, first: 0, page: 1 }));
        },
        onFiltersChange: (filters) => {
            setActiveFilters(filters);
            setLazyParams((current) => ({ ...current, first: 0, page: 1 }));
        },
        exportParams: { filters: queryParams.filters, sorts: queryParams.sorts }
    };
};
export default useBulletinImplementationReportData;
